import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import CropperImage from "../CropperImage";
import ImageUploading from "react-images-uploading";
import { Row, Col } from "react-bootstrap";
import ImageResize from "image-resize";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Resizer from "react-image-file-resizer";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const CreateItemManagement = () => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create Item Management" }));
  const history = useHistory();
  const [tagData, setTagData] = useState([]);

  const [tagGroup, setTagGroup] = useState([]);
  const [tagProduct, setTagProduct] = useState([]);

  const [className, setClassName] = useState();
  const [groupID, setgroupID] = useState();
  const [productID, setproductID] = useState();

  const [item_image_path, setItem_image_path] = useState();
  const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");
  const [listImg, setListImg] = useState([])

  const [images, setImages] = React.useState([]);
  const [imgCount, setImgCount] = useState(0)

  const [listgroupID, setListgroupID] = useState([]);
  const [listproductID, setListproductID] = useState([]);
  const [displayOrder, setDisplayOrder] = useState(0)

  const [stateItem_image_path, setStateItem_image_path] = useState({
    previewItem_image_path: null,
    rawItem_image_path: null,
    imageURLItem_image_path: null,
  });
  const maxNumber = 10;

  const handleUpload_image_Details = async (file) => {
    const image = await resizeFile(file);

    imageResize
      .play(URL.createObjectURL(file)) //แปลงไฟล์เป็น blob
      .then(async function (response) {
        const trans = dataURLtoFile(image, 'img.png')
        var formdata = new FormData();
        let token = localStorage.getItem("Token");
        formdata.append("image", trans, URL.createObjectURL(trans));
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
        await fetch(`${baseURLV1}/upload`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            let res = JSON.parse(result);
            let fullPath = `${baseURL}/uploads/${res.filename}`

            setListImg(listImg => [...listImg, fullPath])
          })
          .catch((error) => console.log("error", error));
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const imageResize = new ImageResize({
    format: "png", // ไฟล์รูปภาพเป็น png
    quality: 0.5, // ปรับขนาดไฟล์รูปภาพให้เหลือครึ่งนึง
    width: 500, // ปรับขนาดรูปให้มีความกว้าง 500 px
  });
  const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                3000,
                "PNG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const removeListIMG = (index) => {
    console.log(index)
    let arr = listImg
    arr.splice(index, 1);

    console.log(arr)

    setListImg(arr)
  }

  const onChange = async (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
    if (imgCount == 0) {
      console.log('x', imgCount)
      setImgCount(imageList.length)
      await Promise.all(imageList.map(async (item, index) => {
        await handleUpload_image_Details(item.file)
      }))
    } else {
      console.log('y', imgCount)

      if (imageList.length > imgCount) {
        await Promise.all(imageList.map(async (item, index) => {
          if (index > imgCount - 1) {
            await handleUpload_image_Details(item.file)
          }
        }))
        setImgCount(imageList.length)

      }
    }

    console.log('img', listImg)
  };

  const handleChangeItem_image_path = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = '';
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          var height = this.height;
          var width = this.width;
          if (height < 512 || width < 512) {
            Swal.fire(
              "Upload !",
              "At least you can upload a 512*512 photo size. !! ",
              "error"
            );
            e.target.value = '';
            return false;
          } else {
            setStateItem_image_path({
              rawItem_image_path: file,
              imageURLItem_image_path: e.target.result,
            });
            e.target.value = '';
            return true;
          }
        };
      };
    }
  };

  const handleCancelUploadItem_image_path = () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
  };

  const handleImageUploadItem_image_path = async (file) => {
    var formdata = new FormData();
    let token = localStorage.getItem("Token");
    formdata.append("image", file, URL.createObjectURL(file));

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${baseURLV1}/upload`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        setStateItem_image_path({
          previewItem_image_path: null,
          rawItem_image_path: null,
          imageURLItem_image_path: null,
        });
        let fullPath = `${baseURL}/uploads/${res.filename}`
        setItem_image_path(fullPath);
        setNameImageItem_image_path(fullPath);
      })
      .catch((error) => console.log("error", error));
  };

  const removeImageItem_image_path = async () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
    setItem_image_path("");
  };

  const AlertError = (message) => {
    Swal.fire("Alert", message, "error");
  };

  const getListGroup = async () => {
    const apiUrls = `${baseURLV1}/product/itemGroup?page=1&limit=10000`;
    let token = localStorage.getItem("Token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        setListgroupID(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getListProduct = async () => {
    const apiUrls = `${baseURLV1}/product/product?page=1&limit=10000`;
    let token = localStorage.getItem("Token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        setListproductID(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  useEffect(() => {
    getListGroup()
    getListProduct()

  }, []);

  const handleChangeGroup = (event) => {
    console.log(event.target.value)
    setgroupID(event.target.value);
  };

  const handleChangeProduct = (event) => {
    console.log(event.target.value)
    setproductID(event.target.value);
  };


  const onSubmit = async (data) => {
    if (className === undefined || className === "") {
      return AlertError("Please insert class name !!");
    }

    if (tagGroup === undefined || tagGroup.length === 0) {
      return AlertError("Please insert group id !!");
    }

    if (tagProduct === undefined || tagProduct.length === 0) {
      return AlertError("Please insert product id !!");
    }

    if (listImg === undefined || listImg.length === 0) {
      return AlertError("Please insert image !!");
    }



    var events = {
      name: className,
      group_item_id: JSON.stringify(tagGroup),
      product_id: JSON.stringify(tagProduct),
      img: JSON.stringify(listImg),
      ordering: String(displayOrder)

    };

    let apiUrls = `${baseURLV1}/product/item`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "Your can not create item. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Create Item Management"></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Name" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={className}
              onChange={(e) => setClassName(e.target.value)}
            />
          </div>
          {/*<div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Details" })}:{" "}
            </p>
            <textarea

              name="topic"
              style={{
                resize: 'none',
                height: "150px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={machineId}
              onChange={(e) => setMachineId(e.target.value)}
            />
          </div>*/}

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Group Name" })}:{" "}
            </p>
            {/*<select
              as="select"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={groupID}
              onChange={handleChangeGroup}
            >
              <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
              {listgroupID &&
                listgroupID.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.name}
                    </option>
                  );
                })}
            </select>*/}
            <Autocomplete
              multiple
              id="grouped-demo"
              options={listgroupID}
              getOptionLabel={(option) => option.name}
              getOptionSelected={(option, value) => option.id === value.id}
              value={tagGroup}
              onChange={(event, newValue) => {
                console.log(newValue)
                setTagGroup(newValue);
              }}
              style={{
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              renderInput={(params) =>
                <TextField {...params} variant="outlined" />
              }
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Product Name" })}:{" "}
            </p>
            {/*<select
              as="select"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={productID}
              onChange={handleChangeProduct}
            >
              <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
              {listproductID &&
                listproductID.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.name}
                    </option>
                  );
                })}
            </select>*/}
            <Autocomplete
              multiple
              id="grouped-demo"
              options={listproductID}
              getOptionLabel={(option) => option.name}
              getOptionSelected={(option, value) => option.id === value.id}
              value={tagProduct}
              onChange={(event, newValue) => {
                console.log(newValue)
                setTagProduct(newValue);
              }}
              style={{
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              renderInput={(params) =>
                <TextField {...params} variant="outlined" />
              }
            />
          </div>

          <div className="form-inline" style={{ marginBottom: '25px' }}>
            <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
              <span style={{ color: "red" }}>
                *
              </span>
              display order
            </p>
            <input
              name="displayOrder"
              type="number"
              style={{
                height: '38px',
                width: '530px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              value={displayOrder}
              onChange={displayOrder => {
                if (displayOrder.target.value >= 0) {
                  setDisplayOrder(displayOrder.target.value)
                }
              }
              }
            />
          </div>

          <ImageUploading
            multiple
            value={images}
            onChange={onChange}
            maxNumber={maxNumber}
            dataURLKey="data_url"
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps
            }) => (
              <div>
                <div className="form-inline" style={{ marginBottom: "25px" }}>
                  <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                    <span style={{ color: "red" }}>
                      *
                    </span>
                    {intl.formatMessage({ id: "###", defaultMessage: "Details image" })} : <br></br>

                  </p>
                  <div
                    className="d-flex"
                    style={{
                      width: "530px",
                    }}>


                    <span className="btn btn-primary btn-file wbt"
                      style={{
                        whiteSpace: "nowrap",
                        width: "fit-content"
                      }}
                      onClick={() => {
                        onImageUpload()
                      }}
                      {...dragProps}
                    >
                      {intl.formatMessage({ id: "104025", defaultMessage: "Upload/Edit" })}
                    </span>

                    <button
                      type="button"
                      className="btn btn-danger wbt"
                      onClick={onImageRemoveAll}
                    >
                      {intl.formatMessage({ id: "104026", defaultMessage: "delete all" })}
                    </button>


                  </div>

                </div>
                <div className="upload__image-wrapper">

                  <Row>
                    {imageList.map((image, index) => (
                      <Col style={{ marginTop: '20px' }} xs="3">
                        <div key={index} className="image-item">
                          <button className="btnRight" onClick={() => {
                            onImageRemove(index)
                            console.log(index)
                            removeListIMG(index)
                          }}>
                            <img
                              style={{
                                width: "30px",
                                height: "30px",
                              }}
                              src="/media/icon/close.png" />
                          </button>
                          <img src={image.data_url} alt="" width="200" />

                        </div>
                      </Col>

                    ))}
                  </Row>

                </div>
              </div>
            )}
          </ImageUploading>

          <div
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "50%",
            }}
          >
            {stateItem_image_path.imageURLItem_image_path ? (
              <img
                style={{
                  width: "300px",
                  height: "300px",
                }}
                src={stateItem_image_path.imageURLItem_image_path}
              />
            ) : item_image_path ? (
              <img
                style={{
                  width: "300px",
                  height: "300px",
                }}
                src={item_image_path}
              />
            ) : null}
          </div>
          {stateItem_image_path.imageURLItem_image_path ? (
            <CropperImage
              image={stateItem_image_path.imageURLItem_image_path}
              handleCancel={handleCancelUploadItem_image_path}
              handleUpload={handleImageUploadItem_image_path}
              scale={1}
            />
          ) : (
            ""
          )}


          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/ItemManagement">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
